namespace Ir.Components.ReportTemplateEditor.ReportTemplateEditor {
    export interface IViewModel {
        gridConfig: DevExpress.ui.dxDataGrid.Properties;
        gridComponent: DevExpress.ui.dxDataGrid;
        gridFormEditComponent: DevExpress.ui.dxDataGrid;

        reportTemplates: Array<ReportTemplate>;
    }

    interface IParams {
        mappingId: number;
    }

    export function getViewModel(this: IViewModel, params: IParams, componentInfo) {
        load(this, params);

        let store = new DevExpress.data.CustomStore({
            key: "id",
            load() {
                return self.reportTemplates;
            },
            insert(values) {
                let d = $.Deferred();

                let report = values;
                report.save(params.mappingId, (data) => {
                    d.resolve(data.success);
                });

                load(self, params);
                //forceTablesUpdate();

                return d.promise();
            },
            update(key, values) {
                let d = $.Deferred();

                let report = self.reportTemplates.find(x => x.id === key);
                Object.assign(report, values);
                report.save(params.mappingId, (data) => {
                    d.resolve(data.success);
                });

                //forceTablesUpdate();
                return d.promise();
            },
            remove(key) {
                let d = $.Deferred();

                let report = self.reportTemplates.find(x => x.id === key);
                if (report) {
                    report.delete(params.mappingId, (result) => {
                        d.resolve(result.success);
                    });

                    load(self, params);
                }

                //forceTablesUpdate();
                return d.promise();
            }
        });

        let editingRow: ReportTemplate = null;

        let self = this;
        this.gridConfig = {
            //focusedRowEnabled: true,
            //focusedRowIndex: 0,
            keyExpr: "id",
            rowAlternationEnabled: false,

            dataSource: store,
            columns: [
                {
                    dataField: "order",
                    visible: false
                },
                {
                    dataField: "name",
                    validationRules: [{
                        message: "Name is not unique",
                        type: 'custom',
                        validationCallback(e) {
                            let valid = self.reportTemplates.filter(x => x.name == e.value && x.id !== e.data.id).length == 0;
                            return valid;
                        }
                    }, {
                        type: "custom",
                        validationCallback(v) {
                            if (v.value === undefined || v.value === null) {
                                return false;
                            }

                            if (v.value.trim() === "") {
                                return false;
                            }

                            return true;
                        },
                        message: "Name is required"
                    }]
                },                
                { dataField: "fieldsMetricsConcat" },
                {
                    dataField: "visibility",
                    dataType: 'boolean',
                    editorType: 'dxSwitch',
                    width: 75
                },
                {
                    dataField: "aggregate",
                    dataType: 'boolean',
                    editorType: 'dxSwitch',
                    width: 75
                },
                {
                    dataField: "config",
                    visible: false
                },
                {
                    type: "buttons",
                    buttons: [{
                        hint: "Edit",
                        icon: "edit",
                        onClick(e) {
                            editReport(params, e.row.data);
                        }
                    }, "delete", {
                        hint: "Report Info",
                        icon: "contentlayout",
                        onClick(e) {
                            Ir.Components.General.ForeignKeyInfo.show({
                                title: `Report Info: ${e.row.data.name}`,
                                url: `${urlConfigs.mapping}/ReportInfo?id=${params.mappingId}&reportId=${e.row.data.id}`,
                                createTabs(result) {
                                    return createDataSourceReportInfo(result);
                                }
                            } as General.ForeignKeyInfo.IForeignKeyInfoParams);
                        }
                    }]
                }
            ],
            editing: {
                mode: "cell",
                allowUpdating: true,
                allowDeleting: true,
                allowAdding: true,
                useIcons: true,
                confirmDelete: false
            },
            toolbar: {
                items: [
                    {
                        cssClass: "customAddRowDataGridAdmin", location: "before",
                        widget: 'dxButton',
                        options: {
                            icon: "add",
                            text: 'Create Report',
                            onClick(e) {
                                let o = {
                                    url: `${urlConfigs.reportTemplate}GetConfig`,
                                    data: { mappingId: params.mappingId, reportTemplateId: 0 },
                                    dataType: "json",
                                    async: false
                                } as RequestServerParams;
                                o.successFunction = function (data) {
                                    const mapping = MappingService.getMapping(params.mappingId);
                                    let newName = "New Report";
                                    let count = 1;
                                    const names = mapping.originalReports.map(x => x.name);
                                    while (names.includes(newName)) {
                                        newName = `New Report ${count}`;
                                        count++;
                                    }

                                    let order = 0;
                                    if (!self.reportTemplates.every(x => x.order === 0)) {
                                        order = Math.max(...self.reportTemplates.map(x => x.order)) + 1;
                                    }

                                    let newReportTemplate = new ReportTemplate({ config: data, name: newName, order }, true);
                                    mapping.addOriginalReport(newReportTemplate);

                                    load(self, params);
                                    self.gridComponent.refresh();
                                    editReport(params, newReportTemplate, () => {
                                        mapping.removeOriginalReport(newReportTemplate);
                                        load(self, params);
                                        self.gridComponent.refresh();
                                    });
                                };
                                o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
                                    errorItem.userMessage = "Failed to get new report template";
                                    irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                                };

                                irGlobal.requestServer(o);
                            }
                        },

                    },
                    { name: "searchPanel", location: "after" }
                ]
            },
            scrolling: {
                useNative: false
            },
            searchPanel: {
                visible: true,
                placeholder: 'Search...',
                searchVisibleColumnsOnly: true
            },
            paging: {
                enabled: false
            },
            sorting: {
                mode: 'none',
            },
            loadPanel: {
                enabled: false,
                showIndicator: false,
                showPane: false
            },
            rowDragging: {
                allowReordering: true,
                dropFeedbackMode: 'push',
                onReorder(e) {
                    const visibleRows = e.component.getVisibleRows();
                    const toIndex = self.reportTemplates.findIndex((item) => item.id === visibleRows[e.toIndex].data.id);
                    const fromIndex = self.reportTemplates.findIndex((item) => item.id === e.itemData.id);

                    self.reportTemplates.splice(fromIndex, 1);
                    self.reportTemplates.splice(toIndex, 0, e.itemData);

                    updateAndSaveOrder(self, params);

                    e.component.refresh();
                },
            },
            onInitialized(e) {
                self.gridComponent = e.component;
            },
            onEditingStart(e) {
                if (e.column) {
                    e.cancel = e.column.dataField === "fieldsMetricsConcat";
                }

               editingRow = e.data;
            },
            onOptionChanged(e) {
                if (e.name === "searchPanel" && e.fullName === "searchPanel.text" && self.gridComponent) {
                    self.gridComponent.option("rowDragging.allowReordering", e.value ? false : true);
                }
            },
            onRowRemoving(e) {
                let def = jQuery.Deferred();
                let result = DevExpress.ui.dialog.confirm(`Are you sure you want to delete the ${e.data.name}?`, "");
                result.done(function (dialogResult) {
                    def.resolve(!dialogResult);
                });
                e.cancel = def.promise();
            },
            onCellPrepared(e) {
                if (e.rowType === "data" && e.rowIndex % 2 === 0) {
                    e.cellElement.addClass("ir-row-alternation-color");
                }
            }
        } as any;
    }

    function load(self: IViewModel, params: IParams) {
        const mapping = MappingService.getMapping(params.mappingId);
        self.reportTemplates = mapping.originalReports.filter(x => !x.parentItemId);
    }

    function updateAndSaveOrder(self: IViewModel, params: IParams) {
        const mapping = MappingService.getMapping(params.mappingId);

        let order = 0;
        let reports: Array<ReportTemplate> = [];
        for (let report of self.reportTemplates) {
            report.order = ++order;
            reports.push(report);

            let children = mapping.originalReports.filter(x => x.parentItemId === report.id);
            for (let child of children) {
                child.order = report.order;
                reports.push(child);
            }
        }

        let o = {
            url: `${urlConfigs.reportTemplate}SaveOrder`,
            data: { mappingId: params.mappingId, reportsTemplate: reports.map(x => ({ id: x.id, order: x.order, parentItemId: x.parentItemId })) },
            dataType: "json",
            async: false,
        } as RequestServerParams;
        o.successFunction = function () {
            mapping.forceReloadReports();
        };
        o.failureFunction = function (textStatus, failureText, errorItem: IError) {
            errorItem.userMessage = `Failed to get the mapping reports`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, failureText);
        };

        irGlobal.requestServer(o);
    }

    function createDataSourceReportInfo(data) {
        return [
            {
                name: "Workbooks",
                dataSource: data.workbooks,
                columns: [
                    { dataField: "workbookId", caption: "Id", dataType: "string" },
                    { dataField: "workbookName", caption: "Name" },
                    { dataField: "tabName" },
                    { dataField: "source" },
                    { dataField: "owner" },
                    {
                        type: 'buttons',
                        width: 50,
                        buttons: [{
                            hint: 'Open workbook',
                            icon: 'link',
                            onClick(e) {                                
                                let o = {
                                    url: `${urlConfigs.tabs}CanAccessWorkbook`,
                                    data: {
                                        userId: loggedUser.id(),
                                        workbookId: e.row.data.workbookId,
                                        companyId: loggedUser.companyId()
                                    },
                                    dataType: "json",
                                    async: false,
                                } as RequestServerParams;
                                o.successFunction = function (data) {
                                    if (data.success) {
                                        if (e.row.data.tabId > 0) {
                                            window.open(`${window.location.origin}/wb/edit/${e.row.data.workbookId}?tabId=${e.row.data.tabId}`, '_blank').focus();
                                        }
                                        else {
                                            window.open(`${window.location.origin}/wb/edit/${e.row.data.workbookId}`, '_blank').focus();
                                        }
                                    }
                                    else {
                                        DevExpress.ui.notify(data.message);
                                    }
                                };
                                o.failureFunction = function () {
                                    DevExpress.ui.notify("Workbook not found or no access permission");
                                };

                                irGlobal.requestServer(o);
                            }
                        }],
                    }
                ]
            }
        ];
    }

    function editReport(params: IParams, reportTemplate: ReportTemplate, onCancel: () => void = null) {
        Ir.Components.ReportDesigner.ReportDesigner.showEditor(null, {
            mappingId: params.mappingId,
            reportId: reportTemplate.id,
            onSave(config) {
                onSave(params, reportTemplate, config);
            },
            onCancel() {
                if (onCancel) {
                    onCancel();
                }
            }
        } as Ir.Components.ReportDesigner.ReportDesigner.IOpenAdmin);
    }

    function onSave(params: IParams, currentReport: ReportTemplate, reportConfig: ReportConfig) {
        currentReport.config.updateAfterReportDesigner(reportConfig);
        currentReport.save(params.mappingId);
    }
}